import {useNavigate} from "react-router-dom";
import config from "../../config/apiService.json";
import useData from "../public/useData";
import * as z from "zod";

const MAX_FILE_SIZE = 1000000;
const ACCEPTED_IMAGE_TYPES = [
  "image/jpeg",
  "image/jpg",
  "image/png",
  "image/webp",
];

const serviceNameMaxCharacterLength = 30;
const timeOfSettlementMaxCharacterLength = 20;
const applicationFeeMaxCharacterLength = 20;

const schema = z.object({
  image: z
  .any()
  .refine((file) => file instanceof File, `Required`)
  .refine(
      (file) => ACCEPTED_IMAGE_TYPES.includes(file?.type),
      "Only .jpg, .jpeg, .png and .webp formats are supported."
  )
  .refine((file) => file?.size <= MAX_FILE_SIZE, `Max image size is 1MB.`),
  name: z.string().trim().min(1, "Required").max(serviceNameMaxCharacterLength, {message: `Max length is ${serviceNameMaxCharacterLength}`}),
  settlementTime: z.string().max(timeOfSettlementMaxCharacterLength, {message: `Max length is ${timeOfSettlementMaxCharacterLength}`}).optional(),
  applicationFee: z.string().max(applicationFeeMaxCharacterLength, {message: `Max length is ${applicationFeeMaxCharacterLength}`}).optional(),
  necessaryDoc: z.string().optional(),
  workProcedure: z.string().optional(),
});

const useServices = () => {
  // const [data, setData] = useState([]);
  // const [isLoading, setLoading] = useState(true);
  // const { services, administrative } = config;
  // const navigate = useNavigate();
  //
  // const getData = async () => {
  //     const result = await fetchData(services);
  //     setData(result);
  //     setLoading(false);
  // };
  //
  // useEffect(() => {
  //     getData();
  // }, []);
  //
  // const handleDelete = async (serviceId) => {
  //     try {
  //         Swal.fire({
  //             title: 'Are you sure?',
  //             text: "You won't be able to revert this!",
  //             icon: 'warning',
  //             showCancelButton: true,
  //             confirmButtonColor: '#354e80',
  //             cancelButtonColor: '#d33',
  //             confirmButtonText: 'Yes, delete it!'
  //         }).then(async (result) => {
  //             if (result.isConfirmed) {
  //                 await deleteMethod(`${administrative.home.services}/${serviceId}`);
  //                 await getData();
  //                 Swal.fire(
  //                     'Deleted!',
  //                     'Your file has been deleted.',
  //                     'success'
  //                 )
  //             }
  //         });
  //     } catch (ex) {
  //         toast.error(ex.response.data);
  //     }
  // };
  //
  // const handleAddService = () => {
  //     const service = {
  //         "name": "",
  //         "workProcedure": "",
  //         "necessaryDoc": "",
  //         "settlementTime": "",
  //         "applicationFee": "",
  //         "image": null
  //     }
  //     navigate("/admin/services/new", { state: { service } });
  // };
  //
  // return { data, isLoading, handleDelete, handleAddService };

  const navigate = useNavigate();
  const {services} = config;
  const {data, isLoading, error, remove, update, create} = useData(services)

  const navgateToServiceAddPage = () => {
    navigate("/admin/services/new");
  }

  return {data, isLoading, error, schema, navgateToServiceAddPage, remove, create, update};
};

export default useServices;
